import script from "./passCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./passCheck.vue?vue&type=script&setup=true&lang=js"

import "./passCheck.vue?vue&type=style&index=0&id=56d46909&lang=scss"

const __exports__ = script;

export default __exports__